const formatLinkDate = (dateStr) => {
  const date = dateStr ? new Date(dateStr) : new Date();
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
};

const getTrackingLinkUrl = (urlParam) => {
  if (typeof urlParam === "string") return urlParam;
  return (
    urlParam?.redirectUrl ??
    urlParam?.redirect_url ??
    urlParam?.url ??
    urlParam?.directUrl ??
    urlParam?.direct_url ??
    ""
  );
};

const SchedulePopup = ({ item, day, close, onSchedule, onCreateLink }) => {
  const canCreateLink = item?.offer_id?.link_type === "OFFER";

  const handleCopyLink = async (urlParam) => {
    const url = getTrackingLinkUrl(urlParam);
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // ignore clipboard errors
    }
  };

  return (
    <div className="NewStrategyModalOverlay">
      <div className="DeleteCalendarModal">
        <div className="w-full flex flex-col items-start gap-3 self-stretch">
          <div className="flex justify-between self-stretch">
            <div
              className={
                "flex h-8 px-3 items-center gap-[6px] rounded-lg bg-[#F6F6F9] text-[#15151F] font-['Inter'] text-xs font-semibold leading-normal"
              }
            >
              <img
                alt={"Logo"}
                src={"/media/icons/clockGray.svg"}
                className={"w-[18px] h-[18px]"}
              />
              Schedule
            </div>
            <button className={"CloseIconButton"} onClick={close}>
              <img
                alt={"Logo"}
                src={"/media/icons/closeIcon.svg"}
                className={"w-5 h-5"}
              />
            </button>
          </div>
          <div
            className={
              "flex p-[6px] justify-center items-start gap-2 rounded-lg bg-[#F6F6F9]"
            }
          >
            <div className="flex items-center gap-1">
              <div className="flex items-center gap-1">
                <div>
                  <img
                    alt={"Logo"}
                    src={"/media/icons/offer.svg"}
                    className={"w-[14px] h-[14px]"}
                  />
                </div>
                <div className="text-[#8185A8] font-['Inter'] text-xs font-medium leading-[18px]">
                  Offer Name:
                </div>
              </div>
              <div className="text-[#15151F] font-['Inter'] text-xs font-semibold leading-[18px]">
                {item?.offer_id?.name}
              </div>
            </div>
          </div>
        </div>
        <div className={"HorizontalDivider"}></div>
        <div className="flex flex-col gap-2 items-start self-stretch">
          <div className="flex justify-between items-center self-stretch">
            <div className="flex items-center gap-[6px]">
              <img
                alt={"Logo"}
                src={"/media/icons/link-03.svg"}
                className={"w-[14px] h-[14px]"}
              />
              <span className="text-[#171717] font-['Inter'] text-[11px] font-medium leading-normal tracking-[0.88px] uppercase">
                TRACKING LINKS
              </span>
            </div>
            <button
              type="button"
              className="flex h-9 px-4 py-[7px] justify-center items-center gap-[10px] rounded-lg border border-[#D9D9D9] bg-white disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={!canCreateLink}
              onClick={() => onCreateLink?.(item, day)}
            >
              <div className="flex items-center gap-1">
                <img
                  alt={"Logo"}
                  src={"/media/icons/purplePlusIcon.svg"}
                  className={"w-4 h-4"}
                />
                <span className="text-[#7E50EA] font-['Inter'] text-xs font-semibold leading-normal">
                  Create Link
                </span>
              </div>
            </button>
          </div>
          {item?.url?.length > 0 ? (
            <div className="flex flex-col items-start gap-2 self-stretch max-h-[320px] overflow-y-auto">
              {item.url.map((urlParam, index) => (
                <div
                  key={
                    urlParam?._id ?? `${getTrackingLinkUrl(urlParam)}-${index}`
                  }
                  className="flex p-3 flex-col items-start gap-2 self-stretch rounded-lg border border-[#E5E7F0] bg-white"
                >
                  <div className="flex justify-between items-center self-stretch">
                    <div className="ActiveBox">Active</div>
                    <div className="text-[#8185A8] font-['Inter'] text-xs font-medium leading-[18px]">
                      {formatLinkDate(
                        urlParam?.createdAt ??
                          urlParam?.created_at ??
                          item?.date
                      )}
                    </div>
                  </div>
                  <div className="flex justify-between items-start gap-2 self-stretch">
                    <div className="text-[#15151F] font-['JetBrains_Mono'] text-xs font-medium leading-[18px] break-all flex-1 min-w-0">
                      {getTrackingLinkUrl(urlParam)}
                    </div>
                    <div className="flex items-center gap-3 shrink-0">
                      <button
                        type="button"
                        onClick={() => handleCopyLink(urlParam)}
                      >
                        <img
                          alt={"Copy"}
                          src={"/media/icons/copy.svg"}
                          className={"w-[18px] h-[18px]"}
                        />
                      </button>
                      <button
                        type="button"
                        className="disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={!canCreateLink}
                        onClick={() => onCreateLink?.(item, day)}
                      >
                        <img
                          alt={"Edit"}
                          src={"/media/icons/edit-04.svg"}
                          className={"w-[18px] h-[18px]"}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex h-[183px] px-[10px] py-[7px] flex-col justify-center items-center gap-[10px] self-stretch rounded-lg border border-dashed border-[rgba(129,133,168,0.50)] bg-white">
              <div className="flex w-12 h-12 justify-center items-center gap-[10px] shrink-0 rounded-[30px] bg-[#F6F6F9]">
                <img
                  alt={"Logo"}
                  src={"/media/icons/link-03.svg"}
                  className={"w-6 h-6"}
                />
              </div>
              <div className="flex w-[320px] flex-col items-center gap-[6px]">
                <div className="text-[#8185A8] font-['Inter'] text-sm font-semibold leading-[18px]">
                  No link has been created yet
                </div>
                <div className="self-stretch text-center text-[#8185A8] font-['Inter'] text-xs font-normal leading-[18px]">
                  If it’s an Everflow offer, you can create a tracking link
                  using “Create Link.” This is optional.
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={"HorizontalDivider"}></div>
        <div className={"flex justify-between items-center self-stretch"}>
          <button className={"CloseButton"} onClick={close}>
            Close
          </button>
          <button
            className={"PrimaryButton w-[151px]"}
            onClick={() => onSchedule?.(item, day)}
          >
            Schedule
          </button>
        </div>
      </div>
    </div>
  );
};

export default SchedulePopup;
